import Offcanvas from 'bootstrap/js/dist/offcanvas';



export function initNavigation() {
    burgerMenu()
    dropdownMenu();
    initOfCanvasTop();
    changeMegaMenuThumbnail()
    // runStickyNav();
}

function changeMegaMenuThumbnail(){
    document.querySelectorAll('.mega-menu-product .mega-menu__menu-link').forEach(link => {
        link.addEventListener('mouseenter', () => {
            let dataImage = link.getAttribute('data-image');
            let megaMenuImageElm = document.querySelector('.mega-menu-product .mega-menu__image');
            megaMenuImageElm.src = dataImage
        });
    });

    document.querySelectorAll('.mega-menu-product .mega-menu__sub-menu-link').forEach(subMenuLink => {
        subMenuLink.addEventListener('mouseenter', () => {
            let dataImage = subMenuLink.getAttribute('data-image');

            let megaMenuImageElm = document.querySelector('.mega-menu-product .mega-menu__image');
            megaMenuImageElm.src = dataImage
        });
    });
}

function burgerMenu(){
    const navbarOffcanvasElm = document.getElementById('offcanvasNavbar')
    const bsOffcanvas = new Offcanvas('#offcanvasNavbar')
    let isClosed = false;
    let burgerMenu = document.querySelector("#hamburger")
    let btnToggler=document.querySelector('.custom-navbar__navbar-toggler');

    btnToggler.addEventListener('click', (event)=>{  
        event.preventDefault();
        if (isClosed== true) {
            burgerMenu.classList.remove("open");
            burgerMenu.classList.add("closed");
            isClosed  = false;
            bsOffcanvas.hide();
        } else {
            burgerMenu.classList.remove("closed");
            burgerMenu.classList.add("open");
            isClosed = true;
            bsOffcanvas.show();
        }
    });

    navbarOffcanvasElm.addEventListener('hidden.bs.offcanvas', event => {
        burgerMenu.classList.remove("open");
        burgerMenu.classList.add("closed");
        isClosed  = false;
    })
}
function dropdownMenu() { 
    // Get all menu items with the class navbar-custom__menu-item
    const menuItemHasChildren=document.querySelectorAll('.menu-item-has-children');
    const menuLinks = document.querySelectorAll('.menu-item-has-children > .custom-navbar__menu-link');
    const submenuLinks = document.querySelectorAll('.sub-menu  .custom-navbar__menu-link');
    // // Add an event listener to each menu item
    const svgIcon = `<svg class="custom-navbar__menu-icon one"  width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5463_7126)">
<path d="M10.75 16.75L17 10.5M17 10.5L10.75 4.25M17 10.5H2" stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="square"/>
</g>
<defs>
<clipPath>
<rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20.5 0.5)"/>
</clipPath>
</defs>
</svg>

<svg class="custom-navbar__menu-icon two"  width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_5463_7126)">
<path d="M10.75 16.75L17 10.5M17 10.5L10.75 4.25M17 10.5H2" stroke="#A3A3A3" stroke-width="1.5" stroke-linecap="square"/>
</g>
<defs>
<clipPath>
<rect width="20" height="20" fill="white" transform="matrix(-1 0 0 1 20.5 0.5)"/>
</clipPath>
</defs>
</svg>`;
    submenuLinks.forEach((menuLink) => {
        const span = document.createElement("span");
        span.innerHTML = svgIcon;

        // Insert the SVG before the link text
        menuLink.append(span);
    });
    

    if(window.innerWidth <= 1200){
        // Select all elements with the class 'sub-menu'
        const subMenus = document.querySelectorAll('.sub-menu');
        // Loop through each .sub-menu element
        subMenus.forEach(subMenu => {
            // Create a new <li> element
            const newListItem = document.createElement('div');
            // Add classes to the <li> element
            newListItem.classList.add('back-to-root', 'custom-navbar__menu-item');
            
            // Create a new <a> element
            const newLink = document.createElement('a');
            // Set the href and class for the <a> element
            newLink.href = "#";
            newLink.classList.add('custom-navbar__list-menu');

            const svg = document.createElement('span');
            svg.innerHTML = `
                <svg width="20" height="10" viewBox="0 0 20 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.75 1.25L1 5M1 5L4.75 8.75M1 5H19" stroke="#E72920" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                Back`;
            newLink.appendChild(svg);
            
            // Append the <a> element to the <li> element
            newListItem.appendChild(newLink);
            
            // Append the new <li> to the current <ul>
            // subMenu.appendChild(newListItem);
            subMenu.insertBefore(newListItem, subMenu.firstChild);
        });

        menuLinks.forEach((menuLink) => {
            menuLink.addEventListener('click', (e) => {
                e.preventDefault();
                const parentItem = menuLink.parentElement;
                const parentItemActive=parentItem.classList.contains('active');
    
                parentItem.classList.toggle('active');
                menuItemHasChildren.forEach((item) => item.classList.remove('active'));
                
                if(!parentItemActive){
                    parentItem.classList.add('active');
                }
            });
        });
    }



    document.querySelectorAll('.custom-navbar__list-menu').forEach(item => {
        item.addEventListener('click', (e) => {
            e.preventDefault();
            let navbarCustomMenuItem=document.querySelectorAll('.custom-navbar__menu-item.active');
            navbarCustomMenuItem.forEach(item => item.classList.remove('active'));
        });
    });
}

function runStickyNav() {
    window.addEventListener('scroll', stickyNav);
}

function stickyNav(){
    const navHeader = document.querySelector('.navbar-custom');
    const floatingButton=document.querySelector('.floating-button');
    let scrollY=window.scrollY;
    let currentScrollPos = window.scrollY;
    setTimeout(function(){
        if(scrollY<=0){
            navHeader.classList.remove('show');
        } else if(scrollY > 200){
            navHeader.classList.add('show');
            floatingButton.classList.add('show');
        } else {
            navHeader.classList.remove('show');
            floatingButton.classList.remove('show');
        }
    }, 100);
}

function setOffCanvasTop(){
    const customNavbar=document.querySelector('.custom-navbar');
    const customNavbarOffcanvas=document.querySelector('.custom-navbar__offcanvas');
    if(!customNavbar || !customNavbarOffcanvas) {
        console.error('customNavbar or Offcanvas not found');
    }else{
        const customNavbarHeight=customNavbar.clientHeight;
        customNavbarOffcanvas.style.top=customNavbarHeight+'px';
    }
}

export function initOfCanvasTop() {
    window.innerWidth <= 1200 ? setOffCanvasTop() : null;
    window.addEventListener('resize',function(){
        window.innerWidth <= 1200 ? setOffCanvasTop() : null;
    })
}



